var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralSupplyDP = function SvgDAhuGeneralSupplyDP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 635,
    cy: 294,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635,284c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S629.5,284,635,284 M635,283c-6.1,0-11,4.9-11,11s4.9,11,11,11 s11-4.9,11-11S641.1,283,635,283L635,283z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M632.5,290.6h1l2.2,5.7h-5.5L632.5,290.6z M631.5,295.5h2.9l-1.4-3.7L631.5,295.5L631.5,295.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.8,294.3c0,0.6-0.2,1.2-0.5,1.6c-0.3,0.4-0.7,0.6-1.2,0.6c-0.5,0-0.8-0.1-1.1-0.5v2h-1v-5.9h0.9l0,0.4 c0.3-0.3,0.7-0.5,1.1-0.5c0.5,0,0.9,0.2,1.2,0.6S639.8,293.5,639.8,294.3L639.8,294.3L639.8,294.3z M638.9,294.2 c0-0.4-0.1-0.8-0.2-1s-0.4-0.4-0.7-0.4c-0.4,0-0.7,0.2-0.8,0.5v1.9c0.2,0.3,0.5,0.5,0.8,0.5c0.3,0,0.5-0.1,0.7-0.4 C638.8,295.1,638.9,294.7,638.9,294.2L638.9,294.2z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 646,
    y: 293,
    width: 7,
    height: 2
  })))));
};
export default SvgDAhuGeneralSupplyDP;